import { Helmet } from 'react-helmet';
import ContactForm from '../components/contact/ContactForm';
import LocationMap from '../components/contact/LocationMap';
import { motion } from 'framer-motion';
import { FaHeadset } from 'react-icons/fa';

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | VEDUS Supply Chain Management</title>
        <meta name="description" content="Get in touch with VEDUS Supply Chain Management for all your logistics needs. Contact us via phone, email, or WhatsApp for immediate assistance." />
      </Helmet>
      
      <div className="bg-gradient-to-r from-secondary-900 to-secondary-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <FaHeadset className="text-5xl text-primary-400 mx-auto mb-4" />
            <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
            <p className="text-xl text-secondary-300 max-w-3xl mx-auto">
              Have questions or need assistance? Our team is ready to help with all your logistics needs.
            </p>
          </motion.div>
        </div>
      </div>
      
      <div className="py-16 bg-secondary-50 dark:bg-secondary-800">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <ContactForm />
            <LocationMap />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;